import { Inject, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { map } from "rxjs/operators";
import { OdConfig } from "../od-config";
var CustomLanguageLoader = /** @class */ (function () {
    function CustomLanguageLoader(_http, config) {
        this._http = _http;
        this.config = config;
        this._cusFileId = "";
    }
    CustomLanguageLoader.prototype.getTranslation = function (lang) {
        if ("cus" === lang) {
            return this._http.get(this.config.downloadFileUrl + this._cusFileId)
                .pipe(map(function (response) {
                return response;
            }));
        }
        else {
            return this._http.get("assets/i18n/" + lang + ".json")
                .pipe(map(function (response) {
                return response;
            }));
        }
    };
    CustomLanguageLoader.prototype.setCusFileId = function (value) {
        this._cusFileId = value;
    };
    CustomLanguageLoader.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    CustomLanguageLoader.ctorParameters = function () { return [
        { type: HttpClient, },
        { type: OdConfig, decorators: [{ type: Inject, args: ['config',] },] },
    ]; };
    return CustomLanguageLoader;
}());
export { CustomLanguageLoader };
//# sourceMappingURL=custom-language-loader.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/loader/custom-language-loader.js
// module id = 369
// module chunks = 14